export const CONFIDENCE_QUESTION = 'How confident are you in conversations?'

export const CONFIDENCE_OPTIONS = [
  { key: 'freezeUp', i18nKey: 'freezeUp' },
  { key: 'roomToGrow', i18nKey: 'roomToGrow' },
  { key: 'prettySolid', i18nKey: 'prettySolid' },
] as const
